import React from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import capitalizeWords from "../common/formatter";
import { useContext } from "react";
import { Typography } from 'antd';

import { Card, Button, Tag, Flex, Space } from 'antd';
import { CheckOutlined, ExclamationOutlined, EnvironmentOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;
function ProductCard({ product }) {
  const { addToCart } = useContext(CartContext);
  
   const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  console.log("ProductCard BASE_URL:", BASE_URL)

  if (!product) return null;
  console.log("FULL PRODUCT:", product);
  console.log("DELIVERY OPTION FROM API:", product.deliveryOption);
  console.log("TYPE:", typeof product.deliveryOption);

 const discount =
  product.actual_price && product.selling_price
    ? Math.round(
        ((Number(product.actual_price) - Number(product.selling_price)) /
          Number(product.actual_price)) *
          100
      )
    : 0;


const isInStock = product.stock > 0;
  const isLowStock = product.stock > 0 && product.stock <= 5;
   let imageUrl = "/Images/default.jpg"; // fallback
let imagesArray = [];

if (product.images) {
  try {
    imagesArray = Array.isArray(product.images)
      ? product.images
      : JSON.parse(product.images);

    if (imagesArray.length > 0 && imagesArray[0]) {
      imageUrl = `${BASE_URL}${encodeURI(imagesArray[0])}`;
    }
  } catch (err) {
    console.warn("Error parsing images:", err);
  }
}

// Safe console.log
console.log("Product images array:", imagesArray, "Using image URL:", imageUrl);


return (
   <Card
  className="product-card"
  style={{ 
    borderRadius: 8, 
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', 
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%' // allow card to grow
  }}
  cover={
    <Link to={`/product/${product.id}`} style={{ display: 'block' }}>
      <div style={{ position: 'relative', height: 180, overflow: 'hidden', textAlign: 'center', borderBottom: '2px solid #f0f0f0' }}>
       <img
  alt={product.name || "Product"}
  src={
  imageUrl
  }
  style={{ width: "100%", height: "100%", objectFit: "contain", padding: 13 }}
  onError={(e) => {
    e.target.onerror = null; // Prevent infinite loop if fallback also fails
    e.target.src = "/Images/default.jpg";
  }}
/>

        {discount > 0 && (
          <Tag color="#EE152D" style={{ position: 'absolute', top: 12, left: 12, fontSize: "bold", padding: '4px 8px' }}>
            {discount}% OFF
          </Tag>
        )}
      </div>
    </Link>
  }
  bodyStyle={{ padding: 16, display: 'flex', flexDirection: 'column', flexGrow: 1 }}
>
  <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
    {/* Product Name */}
    <Link to={`/product/${product.id}`}>
      <Title 
        level={4} 
        style={{ 
          margin: 0, 
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      title={capitalizeWords(product.name)}

      >
       {capitalizeWords(product.name)}
      </Title>
    </Link>
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
      <Title level={5} style={{ margin: 0, color: '#EE152D' }}>₹{product.selling_price}</Title>
      {Number(product.actual_price) > Number(product.selling_price) && (

        <Text delete type="secondary" style={{ fontSize: 14 }}>₹{product.actual_price}</Text>
      )}
    </div>

    {/* Stock */}
    {isLowStock ? (
      <div style={{ padding: '6px 8px', backgroundColor: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
        <ExclamationOutlined style={{ color: '#faad14' }} />
        <Text strong style={{ color: '#faad14' }}>Low Stock ({product.stock} left)</Text>
      </div>
    ) : isInStock ? (
      <div style={{ padding: '6px 8px', backgroundColor: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
        <CheckOutlined style={{ color: '#52c41a' }} />
        <Text strong style={{ color: '#52c41a' }}>In Stock ({product.stock})</Text>
      </div>
    ) : (
      <Text type="danger" strong>Out of Stock</Text>
    )}

    {/* Pickup */}
    {/* Pickup / Delivery Info */}
{/* Delivery Option */}
<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
  <EnvironmentOutlined style={{ color: '#1129ce' }} />

  <Text>
    {product.deliveryOption === "store_pickup" &&
      "Store Pickup Available"}

    {product.deliveryOption === "home_delivery" &&
      "Home Delivery Available"}

    {product.deliveryOption === "both" &&
      "Store Pickup & Home Delivery Available"}

    {(!product.deliveryOption) &&
      "Delivery information not available"}
  </Text>
</div>


  </div>

  {/* Add to Cart Button */}
  <Button
    size="large"
    disabled={!isInStock}
    onClick={() => isInStock && addToCart(product)}
    style={{ backgroundColor: 'blue', color: 'white', fontWeight: 'bold', marginTop: 12 }}
  >
    {isInStock ? "Add to Cart" : "Unavailable"}
  </Button>
</Card>

  );


}

export default ProductCard;